import Image from 'next/image';
import { ReactNode } from 'react';
import { Typography, Stack } from '@mui/material';
import { usePhrase } from '@/hooks/general/usePhrase/usePhrase';
import { INTRO_PHRASES } from '@/consts/phrases/introPhrases';
import { getThemeProps } from '@/components/layoutUtil';
import { Link } from '@/components/general/Link/Link';
import { Icon } from '@/components/general/Icon/Icon';

export const ExternalBannerLink = () => {
    const { t } = usePhrase();

    const {
        homeLayout: {
            introBanner: {
                visible: isBannerVisible = false,
                imgSrc: bannerImgSrc = '',
                linkUrl: bannerLink = '',
            } = {},
        },
    } = getThemeProps();

    if (!isBannerVisible) return null;

    const BannerTitle = () => (
        <Typography
            variant="subtitle2"
            sx={{
                alignSelf: 'center',
            }}
        >
            {t(INTRO_PHRASES.INTRO_BANNER)}
        </Typography>
    );

    const BannerImage = () => {
        if (!bannerImgSrc) return null;
        return (
            <Image
                src={bannerImgSrc}
                width={127}
                height={32}
                alt={t(INTRO_PHRASES.INTRO_BANNER, {
                    asString: true,
                })}
            />
        );
    };

    const BannerLink = ({ children }: { children: ReactNode }) => (
        <Link
            href={bannerLink}
            target="_blank"
            rel="nofollow noreferrer"
            style={{ display: 'inline-flex' }}
        >
            {children}
        </Link>
    );

    return (
        <Stack
            direction="row"
            className="ExternalBannerLink"
            sx={{
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 1,
                py: 1,
                px: 2,
            }}
        >
            {bannerLink ? (
                <>
                    <BannerLink>
                        <BannerImage />
                        <Stack
                            direction="row"
                            sx={{
                                alignSelf: 'center',
                                gap: 1,
                            }}
                        >
                            <BannerTitle />
                            <Icon path="general/navigationIcons/ArrowRightAltIcon" />
                        </Stack>
                    </BannerLink>
                </>
            ) : (
                <>
                    <BannerImage />
                    <BannerTitle />
                </>
            )}
        </Stack>
    );
};
